import 'jquery_jangle';

import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import Hammer from 'hammerjs';

import MoodLog from 'mood/models/mood_log';


// Private functions
var findPositionFromAngle = function (centerX, centerY, distance, degrees) {
  // Given x, y, distance, and degrees, return an object with x and y that
  // represent the point that is degrees and distance away from the given
  // x and y. (e.g. {x: point_x, y: point_y})
  // degrees here are math degrees, not clock angle
  // the position returned is absolute on the page

  // Adjust degrees by 90 and convert to radians
  var radians = (degrees + 90) * (Math.PI / 180);
  return {
    x: Math.round(centerX + Math.sin(radians) * distance),
    y: Math.round(centerY + Math.cos(radians) * distance)
  };
};


var findRatingFromAngle = function (angle, modulus) {
  // Given a clock angle (0 - 360 with 0 at 12 O'clock and increasing
  // clockwise) and the modulus, return the rating from 0 to modulus - 1
  var denominator = 360 / (modulus - 1);
  return Math.round(angle / denominator);
};


var findClockAngleFromRating = function (rating, modulus) {
  // Given an integer rating and a modulus, return the clock angle
  var factor = 360 / (modulus - 1);
  return findClockAngle(factor * rating);
};


var findClockAngle = function (degrees) {
  // Given degrees expressed in the usual math convention where
  // 0 degrees is at 3 o'clock, 90 is at noon, and so forth counter-clockwise,
  // return an angle that represents angles on a clock
  // (0 degrees at the top, going clockwise so 90 degrees is 3 O'clock)
  // N.B. - This function is an involution so given a clock angle,
  // returns a normal angle.
  return (90 - degrees + 360) % 360;
};


var movePosition = function ($el, angle, x, y) {
  // Given an $element, the rotation angle, x, and y, reposition
  // that element to x, y
  // The position is for the upper left corner of the bounding box
  // so we must offset by half the width and height of the bounding box.
  // The size of the bounding box changes with rotation, so we must
  // compute it.
  var size = rotatedSize($el, angle);
  $el.offset({ top: y - size.height / 2, left: x - size.width / 2 });
};


var rotatedSize = function ($el, angle) {
  angle = angle * Math.PI / 180;
  var sin = Math.sin(angle),
    cos = Math.cos(angle);

  // (0,0) stays as (0, 0)

  // (w,0) rotation
  var x1 = cos * $el.width(),
    y1 = sin * $el.width();

  // (0,h) rotation
  var x2 = -sin * $el.height(),
    y2 = cos * $el.height();

  // (w,h) rotation
  var x3 = cos * $el.width() - sin * $el.height(),
    y3 = sin * $el.width() + cos * $el.height();

  var minX = Math.min(0, x1, x2, x3),
    maxX = Math.max(0, x1, x2, x3),
    minY = Math.min(0, y1, y2, y3),
    maxY = Math.max(0, y1, y2, y3);

  return { width: maxX - minX, height: maxY - minY };
};


var rotate = function ($el, degree) {
  // Given an $element and a degree, rotate the element to that degree
  $el.jangle({
    degrees: degree,
    duration: 0,
    interval: 0
  });
};


export default Backbone.View.extend({
  initialize: function (options) {
    _.bindAll.apply(_, [this].concat(_.functions(this)));

    this.setElement($('#smile-area'));
    this.faceEl = $('#face', this.$el);
    this.smileyEl = $('#smiley', this.$el);
    this.handleEl = $('#handle', this.$el);
    this.moodRatingModulus = 11; // Rating of 0-10 has a modulus of 11
    /* eslint-disable */
    this.hammer = new Hammer(this.smileyEl[0], {
      drag_min_distance: 0,
      drag_horizontal: true,
      drag_vertical: true,
      transform: false,
      hold: false,
      prevent_default: true
    });
    /* eslint-enable */

    this.hammerEvents = {
      drag: 'smileyOnDrag',
      dragend: 'smileyDragEnd'
    };

    // Elements
    this.savingProgress = $('#mood-rater .progress-loading', this.$el);

    this.delegateHammerEvents();
    this.setInitialData();
    window.onorientationchange = this.repositionWidget;
    this.dateNav = options.dateNav || options.parent_view.date_nav;
    this.dateNav.on('change', this.updateAsync);
    $(window).resize(_.debounce(this.repositionWidget, 300));
    $('body').scroll(_.debounce(this.setInitialData, 100));
    // mood logs are in descending order by date, key; so the first is the most
    // recent
    this.collection = options.parent_view.mood_collection;
  },

  repositionWidget: function () {
    this.setInitialData();
    this.update({ silent: true });
  },

  setInitialData: function () {
    var smileyPadding = parseInt(this.smileyEl.css('padding-top'), 10);
    var width = this.smileyEl.width() + smileyPadding * 2;
    var height = this.smileyEl.height() + smileyPadding * 2;

    this.smileyData = {
      radius: parseInt(this.smileyEl.data('radius'), 10),
      x: this.faceEl.width() / 2 + this.faceEl.offset().left,
      y: this.faceEl.height() / 2 + this.faceEl.offset().top,
      height: height,
      width: width
    };
  },

  delegateHammerEvents: function () {
    // Use hammerEvents declaration to bind view methods to events
    var self = this;
    _.each(_.pairs(self.hammerEvents), function (functionPair) {
      var method_name = functionPair[0];
      var callback = functionPair[1];
      // Create a closure and pass self since event overides this
      self.hammer.on(method_name, function (event) {
        self[callback](self, event);
      });
    });
  },

  setMood: function (rating, options) {
    var silent = options && options.silent;
    var degrees = findClockAngleFromRating(rating, this.moodRatingModulus);
    // Derive position, angle, and rating of handle based on degrees
    var handleData = this.find_handle_data(degrees);

    // except that we already know the rating, and the degrees are the same
    // for 0 and 10, so put back the rating we know
    handleData.rating = rating;
    // Update the smiley and handle using the handle data
    this.update_smiley_widget(handleData);
    if (!silent) {
      this.trigger('mood-set', this.currentMood);
    }
  },

  setLoggedMessage: function (message) {
    $('#nothing-logged').text(message);
  },

  updateAsync: function () {
    setTimeout(this.update, 0);
  },

  update: function (options) {
    // user has changed dates
    this.currentMood = this.collection.findWhere({
      date: this.dateNav.formatted_date()
    });
    if (this.currentMood) {
      this.setMood(this.currentMood.get('mood'), options);
      this.setLoggedMessage('');
    } else {
      this.setMood(0, options);
      this.setLoggedMessage('Nothing logged yet.');
    }
  },

  smileyOnDrag: function (self, event) {
    self.smileyEvent(self, event, false);
  },

  smileyDragEnd: function (self, event) {
    var date = this.dateNav.formatted_date();
    var otherMood = self.collection.findWhere({ date: date });
    var rating = self.smileyEvent(self, event, true);
    if (otherMood && rating === otherMood.get('mood')) {
      return;
    }
    if (rating === 0) {
      if (otherMood) {
        self.savingProgress.addClass('active deleting');
        setTimeout(function () {
          self.savingProgress.removeClass('active deleting');
        }, 3000);
        otherMood.destroy({ wait: true, success: function () {
          self.collection.fetch();
          self.update();
        } });
      }
      return;
    }
    self.savingProgress.addClass('active saving');
    setTimeout(function () {
      self.savingProgress.removeClass('active saving');
    }, 3000);
    if (otherMood) {
      otherMood.save({ mood: rating }, { success: self.moodSaved });
    } else {
      self.collection.create(
        new MoodLog({ date: date, mood: rating }),
        { wait: true, success: self.moodSaved });
    }
  },

  moodSaved: function (mood) {
    this.collection.fetch();
    this.trigger('mood-set', mood);
  },

  smileyEvent: function (self, event, roundToRating) {
    // Move the handle and update the smiley given the event and
    // ``roundToRating``, which determines if the angle should
    // be rounded to the nearest integer rating.
    // Returns the chosen rating

    // Determine the relative position of the touch event relative to the smiley
    var touch = _.last(event.gesture.touches);
    var relative_touch = findRelativeTouchData(touch, self.smileyEl);
    // now we should have the x & y distance of the touch relative to the upper left corner of the smiley

    // Find the angle in degrees of the touch relative to the center of smiley
    var smiley = self.smileyData;
    var degrees = getDegree(
      smiley.width / 2, smiley.height / 2, relative_touch.x, relative_touch.y
    );
    // Derive position, angle, and rating of handle based on degrees
    var handle_data = self.find_handle_data(degrees, roundToRating);
    // Update the smiley and handle using the handle data

    self.update_smiley_widget(handle_data);
    return handle_data.rating;
  },

  update_smiley_widget: function (handle_data) {
    // Given handle_data, change the smiley's face and move/rotate the
    // handle
    this.handleEl.attr('class', 'handle' + handle_data.rating);

    $('#face').attr('class', 'face' + handle_data.rating);
    rotate(this.handleEl, handle_data.clock_angle);
    movePosition(
      this.handleEl,
      handle_data.clock_angle,
      handle_data.position.x,
      handle_data.position.y
    );
    this.setLoggedMessage('');
  },

  find_handle_data: function (degrees, roundToRating) {
    // Given degrees and ``roundToRating`` determine
    // the handles rating, position and rotation angle. If
    // ``roundToRating`` is true, round the angle and position to
    // the rating.
    // position is absolute on the page
    roundToRating = roundToRating || false;
    var smiley = this.smileyData;
    var clock_angle, rating;
    var clock_modulus = this.moodRatingModulus;
    if (!roundToRating) {
      // Not rounding, determine the clock angle and rating from the degrees
      clock_angle = findClockAngle(degrees);
      rating = findRatingFromAngle(clock_angle, clock_modulus);
    } else {
      // rounding, determine the degrees from the rating
      rating = findRatingFromAngle(
        findClockAngle(degrees), clock_modulus
      );
      clock_angle = rating * (360 / (clock_modulus - 1));
      degrees = findClockAngle(clock_angle);
    }
    // Determine the appropriate x, y position of the handle
    var position = findPositionFromAngle(
      smiley.x, smiley.y, smiley.radius, degrees
    );
    return {
      clock_angle: clock_angle,
      rating: rating,
      position: position
    };
  }
});

var findRelativeTouchData = function (touch, $el) {
  // Find the x, y of the touch event relative to the upper left corner of the element being
  // touched.
  // touch.x, touch.y should be the absolute position of the touch on the page
  // offset will be the absolute position of the upper left point of the element on the page
  var offset = $el.offset();
  return {
    x: touch.pageX - offset.left,
    y: touch.pageY - offset.top
  };
};
var getDegree = function (center_x, center_y, object_x, object_y) {
  // Given x1, y1, x2, y2, return the angle in degrees that represents
  // the angle of (x2, y2) in relation to (x1, y1)
  // center_x: half the width of the smiley
  // center_y: half the height of the smiley
  // object_x, object_y: position of the touch relative to the upper left of the smiley

  // Find the relative offset of the touch from the center
  var x_delta = object_x - center_x,
    y_delta = center_y - object_y;

  /* x_delta, y_delta should now be the position of the touch relative to the center of the smiley.

                          o touch
                         /|
                        / |
                       /  |
                      /   |
                     /    |
                    /     |
                   /      |  y_delta
                  /       |
                 / ?      |
        center  X---------+
                   x_delta

        We want the angle "?", which is arctan(y_delta / x_delta).

        Using Math.atan2(y, x) is easier here. it gives us the full range of results (-180 to 180),
        whereas atan() can't tell what quadrant you're in because it doesn't know which values were
        negative and which positive.
       */
  var radians = Math.atan2(y_delta, x_delta),
    degrees = radians / (Math.PI / 180);

  // degrees is now the angle of the touch to the center, using the usual mathematical
  // convention where 0 degrees is at 3 o'clock and we go counter-clockwise, so 90 is at 12.
  // (degrees could be negative, it doesn't matter though, it still works.)

  return degrees;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/django-mood/mood/static/js/mood/views/smiley.js
// module id = 167
// module chunks = 0